// extracted by mini-css-extract-plugin
module.exports = {"card":"us-offerings_card__a4go6"};